export default __webpack_public_path__ + "static/media/arrow-right.d10c9405.svg";